import { Geometry } from "./Geometry";
import { Property } from "./Property";
export var FeatureOrigin;
(function (FeatureOrigin) {
    FeatureOrigin["Draw"] = "draw";
    FeatureOrigin["Results"] = "results";
    FeatureOrigin["Edit"] = "edit";
})(FeatureOrigin || (FeatureOrigin = {}));
export class Feature {
    _id;
    _geometry;
    _style;
    _layer;
    _properties = {};
    constructor(id, geometry, layer = undefined) {
        this._id = id;
        this._geometry = geometry;
        this._layer = layer;
    }
    static fromOl(input, crs, layer = undefined) {
        const feature = new Feature(input.getId(), Geometry.fromOl(input.getGeometry(), crs), layer);
        //console.log(input);
        return feature;
    }
    getId() {
        return this._id;
    }
    getTitle() {
        let title = "";
        if (this._layer !== undefined) {
            title += this._layer.getAlias();
        }
        return title;
    }
    getGeometry() {
        return this._geometry;
    }
    setStyle(style) {
        this._style = style;
        return this;
    }
    getStyle() {
        return this._style;
    }
    addProperty(name, value) {
        const property = new Property(name, value, this._layer);
        this._properties[property.getName()] = property;
        return this;
    }
    getProperties() {
        const properties = [];
        Object.keys(this._properties).forEach((name) => {
            properties.push(this._properties[name]);
        });
        return properties;
    }
    getProperty(name) {
        if (Object.prototype.hasOwnProperty.call(this._properties, name)) {
            return this._properties[name];
        }
        return;
    }
}
//# sourceMappingURL=Feature.js.map